import { ConsoleLogger } from "@aws-amplify/core";
import React, { useContext, useState } from "react";
import { AccountContext } from "../../User/Account";

type Props = {
	username: string;
	password: string;
};

const VerifyUser = ({ username, password }: Props) => {
	const [verificationCode, setVerificationCode] = useState("");

	const { VerifyUser, Auth } = useContext(AccountContext);

	const verificationOnClick = async (e: React.FormEvent<EventTarget>) => {
		e.preventDefault();
		VerifyUser(username, verificationCode)
			.then((data: any) => {
				console.log("You verified it! :)", data);
				Auth(username, password)
					.then((data: any) => {
						console.log("Logged In!", data);
					})
					.catch((err: any) => {
						console.error("Failed to Login", err);
					});
			})
			.catch((err: any) => {
				console.log("Verification failed :(");
			});
	};

	return (
		<div>
			<div className="title">
				<h1>You need to verify your account.</h1>
			</div>
			<form>
				<div className="form-group mt-3">
					<label htmlFor="userVerificationCode">
						Verification Code
					</label>
					<input
						onChange={(e) => setVerificationCode(e.target.value)}
						type="text"
						className="form-control mt-3"
						id="userVerificationCode"
						aria-describedby="verificationAria"
						placeholder="Enter verification code."
					/>
				</div>
			</form>
			<div className="footer">
				<button onClick={verificationOnClick}>Verify</button>
			</div>
		</div>
	);
};

export default VerifyUser;
